import { createStorageHelpers } from '@/components/shared/GenericTableSkeleton';

export const TRADES_WIDTH_STORAGE_KEY = 'trades_col_max_widths';

const { getStoredWidths, storeColumnWidths } = createStorageHelpers(TRADES_WIDTH_STORAGE_KEY);
export const getStoredTradesWidths = getStoredWidths;
export const storeTradesColumnWidths = storeColumnWidths;
